import { reportStorageWriteFailure } from "./reportStorageWriteFailure";

const pendingWrites = new Set<Promise<unknown>>();
const listeners = new Set<() => void>();

const notifyListeners = (): void => {
  for (const listener of listeners) {
    listener();
  }
};

export const trackPendingWrite = <Value>(write: Promise<Value>): Promise<Value> => {
  pendingWrites.add(write);
  notifyListeners();

  const forgetWrite = (): void => {
    pendingWrites.delete(write);
    notifyListeners();
  };
  write.then(forgetWrite, (error) => {
    forgetWrite();
    // Le rapport est du best effort : s'il echoue a son tour, il ne doit pas recreer le rejet non
    // capture que ce chemin existe justement pour supprimer.
    reportStorageWriteFailure(error).catch(() => undefined);
  });

  return write;
};

export const getPendingWriteCount = (): number => {
  return pendingWrites.size;
};

export const subscribeToPendingWrites = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const waitForPendingWrites = async (): Promise<void> => {
  while (pendingWrites.size > 0) {
    await Promise.allSettled([...pendingWrites]);
  }
};
